import { BarEditPageLoadReason } from './bar-edit-page-load-reason.enum';

/** BAR edit page initialization arguments. */
export class BarEditPageLoadArgs<TModel = any> {
    /** Reason why the init is invoked */
    reason: BarEditPageLoadReason;
    /** Whether first time load. Load can happen multiple times within the lifecycle of the component. */
    firstLoad: boolean;
    /** The model used to load. */
    model: TModel;
}
